import {inject, Injectable} from '@angular/core';
import {allowedTypes} from "../configs/telegram-chat-window-config";
import {UpdateAccountPhotoParams} from "../types/telegram-page.types";
import {ErrorService} from "../../../../core/services/error.service";
import {TelegramApiService} from "./telegram-api.service";
import {UploadProgressService} from "../../../../core/services/upload-progress.service";
import {TelegramChatWindowService} from "./telegram-chat-window.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramUpdateAccountPhotoService {
  private errorService: ErrorService = inject(ErrorService);
  private telegramApiService: TelegramApiService = inject(TelegramApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private telegramChatWindowService: TelegramChatWindowService = inject(TelegramChatWindowService);

  public validateFile(file: File): boolean {
    const fileType = file.type.toLowerCase();
    const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
    const isValid = allowedTypes.image.mime.includes(fileType) && allowedTypes.image.extensions.includes(fileExtension);
    if (!isValid) {
      this.errorService.showErrorMessage('Пожалуйста, загружайте только изображения в формате JPEG, JPG или PNG.');
    }

    return isValid
  }

  public async updateAccountPhoto(updateAccountPhotoParams: UpdateAccountPhotoParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.telegramApiService.updateAccountPhoto(updateAccountPhotoParams).subscribe({
        next: (event) => {
          const progress = this.telegramChatWindowService.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: updateAccountPhotoParams.fileName,
            fileType: 'image',
          });
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        },
        complete: () => {
          setTimeout(() => {
            this.uploadProgressService.resetProgress();
            resolve();
          }, 1000);
        },
      });
    });
  }
}
